import { authFetch } from 'auth/utils.ts';
import { envVariables } from 'common/utils/envVariables.ts';

export const uploadProductsManagementFile = async (file: File) => {
  const data = new FormData();
  data.append('file', file, file.name);
  const response = await authFetch(
    `${envVariables.VITE_BULK_PRODUCTS_MANAGEMENT_MODULE_REQUESTS_API}`,
    {
      method: 'POST',
      body: data,
    },
  );

  if (!response.ok) {
    await response.text().then((text) => {
      throw new Error(text);
    });
  }
};
